export const WashIconSvg = ({ size = 18, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 12c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 8V6" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M9 9l-1.5-1.5" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <path d="M15 9l1.5-1.5" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);
